export const allowedSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export const allowedColors = [
    'default',
    'prominent',
    'success',
    'warning',
    'error',
];
